import { useEffect, useState } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import { DashSquareFill, PlusSquareFill } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import CustomButton from "../../components/CustomButton/CustomButton";

interface AddAcademyPartnersProps {
    show: boolean;
    handleClose: () => void;
    data?: any;
}

type FormData = {
    title: string;
    subtitle: string;
}

const AddAcademyPartners = ({ show, handleClose, data }: AddAcademyPartnersProps) => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm<FormData>();
    const [images, setImages] = useState<any[]>([
        { file: null }
    ]);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (data) {
            reset({
                title: data.title,
                subtitle: data.subtitle
            });
            setImages(data.logos && data.logos.length ? data.logos : [{ file: null }]);
        } else {
            reset({
                title: '',
                subtitle: ''
            });
            setImages([{ file: null }]);
        }
    }, [data])

    const uploadFile = (file: File, index: number) => {
        const formData = new FormData();
        formData.append("file", file);
        WebService.fileUploadAPI({
            action: `upload`,
            body: formData
        })
            .then((res: any) => {
                if (res.data) {
                    images[index].file = res.data?.url;
                    setImages([...images]);
                }
                toast.success(res.message);
            })
            .catch((err: any) => {
                toast.error(err.response?.data?.message || "An error occurred");
            });
    }

    const onSubmit = (formData: FormData) => {
        if (images.length === 0 || images[0].file === null) {
            toast.error("Please upload at least one logo");
            return;
        }
        setLoading(true);
        WebService.postAPI({
            action: `academy-partners/addContent`,
            body: {
                ...formData,
                logos: JSON.stringify(images)
            }
        })
            .then((res: any) => {
                toast.success(res.message);
                handleClose();
                reset();
                setImages([{ file: null }]);
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
            })
    }

    return (
        <>
            <Offcanvas show={show} onHide={() => {
                handleClose();
            }}
                placement="end"
                className="offcanvas-custom">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{data ? 'Edit' : 'Add'}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-2" controlId="title">
                            <Form.Label className="label">Title</Form.Label>
                            <Form.Control type="text" placeholder="Enter title"
                                {...register("title", { required: 'Title is required' })} />
                            {errors.title && <div className="error-message">{errors.title.message}</div>}
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="subtitle">
                            <Form.Label className="label">Subtitle</Form.Label>
                            <Form.Control type="text" placeholder="Enter subtitle"
                                {...register("subtitle", { required: 'Subtitle is required' })} />
                            {errors.subtitle && <div className="error-message">{errors.subtitle.message}</div>}
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="logos">
                            <Form.Label className="label">Logos</Form.Label>
                            {
                                images.map((image, index) => (
                                    <>
                                        <div className="d-flex mt-2">
                                            <Form.Control
                                                type="file"
                                                accept="image/*"
                                                className="custom-image-upload"
                                                onChange={(e) => {
                                                    const input = e.target as HTMLInputElement;
                                                    const file = input.files && input.files[0];
                                                    if (file) {
                                                        uploadFile(file, index);


                                                    }
                                                }}
                                            />
                                            <div className="d-flex mt-2">
                                                <PlusSquareFill
                                                    onClick={() => {
                                                        setImages([...images, { file: null }]);
                                                    }}
                                                    className="ms-2 me-2 cursor-pointer"
                                                />
                                                {images.length > 1 && <DashSquareFill
                                                    onClick={() => {
                                                        const newImages = images.filter((_, i) => i !== index);
                                                        setImages(newImages);
                                                    }}
                                                    className="cursor-pointer"
                                                />}
                                            </div>
                                        </div>
                                        {(image?.file) && (
                                            <div className="mt-2 event-image">
                                                <img
                                                    src={
                                                        image.file
                                                    }
                                                    alt="Event"
                                                    style={{ maxWidth: "100%", maxHeight: 200, objectFit: "contain" }}
                                                />
                                            </div>
                                        )}
                                    </>
                                ))
                            }
                        </Form.Group>
                    </Form>
                </Offcanvas.Body>
                <div className="d-flex justify-content-end p-3">
                    <CustomButton
                        isLoading={isLoading}
                        label="Save"
                        className="w-100"
                        onClick={handleSubmit(onSubmit)}
                    />
                </div>
            </Offcanvas>
        </>
    )
}

export default AddAcademyPartners;